import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { avisoCorrecto, avisoInformativo, avisoError } from "../../components/AvisosMensajes/MensajesSwalf";
import { guardarVoucher, eliminarVoucher } from "../../../actions/pagosActions";
import { updateStateModalLarge } from "../../../actions/modalActions";

const AddNewVoucherModal = ({ onClose, id_dt_matricula_proyecto, tp_cuota, archivosExistentes = [], areaRegistro = null, onVoucherDeleted }) => {
  const dispatch = useDispatch();
  const [experienceFiles, setExperienceFiles] = useState([]);
  const [salesFiles, setSalesFiles] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [archivosEliminados, setArchivosEliminados] = useState(new Set());
  const [huboCambios, setHuboCambios] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);

  const usuario = useSelector((state) => state.usuario?.usuario || state.usuario || null);
 let rol = (usuario?.nombre_tp_nivel_usuario?.trim().toUpperCase() || "");
if (rol === "EXPERIENCIA") rol = "EXPCLIENTE";
if (rol === "VENTA") rol = "VENTAS";

const esFinanzas = rol === "FINANZAS";
const esVentas = rol === "VENTAS" || rol === "JEFE VENTAS";



const puedeVerExperiencia =
  rol === "EXPCLIENTE" || esVentas || rol === "OPERACIONES" || esFinanzas;

const puedeVerVentas =
  esVentas || rol === "EXPCLIENTE" || rol === "OPERACIONES" || esFinanzas;

const puedeSubirExperiencia = rol === "EXPCLIENTE" || rol === "OPERACIONES";
const puedeSubirVentas = esVentas || rol === "OPERACIONES";


const cardColumnClass = esFinanzas
  ? "col-12"
  : esVentas || rol === "EXPCLIENTE"
    ? "col-12 col-md-8 mx-auto"
    : puedeVerExperiencia && puedeVerVentas
      ? "col-12 col-md-6"
      : "col-12 col-md-8 mx-auto";

const archivosVisiblesVentas = esVentas
  ? [...salesFiles, ...experienceFiles]
  : salesFiles;

const archivosVisiblesExperiencia = rol === "EXPCLIENTE"
  ? [...experienceFiles, ...salesFiles]
  : experienceFiles;




  const expInputRef = useRef(null);
  const salesInputRef = useRef(null);

  // Cargar archivos existentes al abrir el modal
  useEffect(() => {
  if (archivosExistentes && archivosExistentes.length > 0) {

   const archivosCargados = archivosExistentes
  .filter(archivo => archivo.archivo_voucher && !archivosEliminados.has(archivo.archivo_voucher))
  .map(archivo => {
    const rutaArchivo = `${process.env.REACT_APP_API_URL}/files_vouchers/${archivo.archivo_voucher}`;
    const esPdf = archivo.archivo_voucher.toLowerCase().endsWith('.pdf');

    return {
  id: archivo.id_registro_pago_voucher || archivo.id_registro_pago || `${archivo.archivo_voucher}-${Date.now()}-${Math.random()}`,
  name: archivo.archivo_voucher,
  url: rutaArchivo,
  type: esPdf ? 'application/pdf' : 'image/jpeg',
  existente: true,
  id_registro_pago: archivo.id_registro_pago || archivo.id_registro_pago_voucher || archivo.iid,
  area_registro: archivo.area_registro,
  fecha_registro: archivo.fecha_registro || archivo.fecha || archivo.created_at || "",
  subido_por:
  archivo.usuario_registro ||
  archivo.usuario_voucher ||
  archivo.nombre_usuario_registro ||
  archivo.nombre_empleado ||
  archivo.subido_por ||
  "No registrado"

};

    });
    
    const archivosExperiencia = archivosCargados.filter(
  archivo => String(archivo.area_registro) === "1"
);

const archivosVentas = archivosCargados.filter(
  archivo => String(archivo.area_registro) === "2"
);

setExperienceFiles(archivosExperiencia);
setSalesFiles(archivosVentas);

  }
}, [archivosExistentes, areaRegistro, refreshKey, archivosEliminados]);

  const handleFiles = (fileList, type) => {
    const filesArray = Array.from(fileList);

    for (const file of filesArray) {
      if (file.size > 5 * 1024 * 1024) {
        avisoInformativo(`El archivo ${file.name} supera los 5MB.`);
        continue;
      }
      if (!["image/jpeg", "image/png", "application/pdf"].includes(file.type)) {
        avisoInformativo(`Formato no permitido: ${file.name}. Solo JPG, PNG o PDF.`);
        continue;
      }

      const nuevoArchivo = {
        id: Date.now() + Math.random(),
        file: file,
        name: file.name,
        preview: URL.createObjectURL(file),
        type: file.type,
        size: file.size,
        existente: false
      };

      if (type === "experience") {
        setExperienceFiles(prev => [...prev, nuevoArchivo]);
      } else if (type === "sales") {
        setSalesFiles(prev => [...prev, nuevoArchivo]);
      }
    }
  };

  const handleFileInputChange = (e, type) => {
    handleFiles(e.target.files, type);
    e.target.value = "";
  };

  const handleDrop = (e, type) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer?.files?.length) {
      handleFiles(e.dataTransfer.files, type);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleRemoveFile = async (type, indexToRemove, item) => {
  

  // quitar de UI
  if (type === "experience") {
    setExperienceFiles(prev => prev.filter((_, i) => i !== indexToRemove));
  } else {
    setSalesFiles(prev => prev.filter((_, i) => i !== indexToRemove));
  }

  if (item && item.name) {
    const resultado = await dispatch(eliminarVoucher(item.id_registro_pago || null, item.name));
    if (resultado === false) return;
    setArchivosEliminados(prev => new Set([...prev, item.name]));
    setHuboCambios(true);
  }

  avisoCorrecto("Voucher eliminado");
};


  const handleSubmit = (e) => {
    e.preventDefault();

    if (!usuario) {
      avisoInformativo("El usuario aún no está cargado. Intenta nuevamente.");
      return;
    }

    if (experienceFiles.length === 0 && salesFiles.length === 0) {
      avisoInformativo("Debes subir al menos un archivo.");
      return;
    }

    const nuevosExperience = experienceFiles.filter(f => !f.existente);
    const nuevosSales = salesFiles.filter(f => !f.existente);

    if (nuevosExperience.length === 0 && nuevosSales.length === 0) {
      avisoInformativo("Debes subir al menos un archivo nuevo.");
      return;
    }

    const promises = [];

    nuevosExperience.forEach(fileObj => {
      const formData = new FormData();
      formData.append("data", JSON.stringify({
        id_dt_matricula_proyecto,
        tipo_voucher: 1,
         area_registro: 1,
        id_usuario: usuario.id_usuario || usuario.id,
        tp_cuota
      }));
      formData.append("archivo", fileObj.file);
      promises.push(dispatch(guardarVoucher(formData)));

    });

    nuevosSales.forEach(fileObj => {
      const formData = new FormData();
      formData.append("data", JSON.stringify({
        id_dt_matricula_proyecto,
        tipo_voucher: 2,
        area_registro: 2, 
        id_usuario: usuario.id_usuario || usuario.id,
        tp_cuota
      }));
      formData.append("archivo", fileObj.file);
      promises.push(dispatch(guardarVoucher(formData)));

    });

   Promise.all(promises).then((resultados) => {
  const hayError = resultados.some(r => r === false);
  if (hayError) return;

  avisoCorrecto("Vouchers guardados correctamente");
  setHuboCambios(true);

  // Marcar archivos nuevos como existentes para que no se suban de nuevo
  setExperienceFiles(prev => prev.map(f => ({ ...f, existente: true })));
  setSalesFiles(prev => prev.map(f => ({ ...f, existente: true })));
});

  };

  const renderMiniPestanas = (files, type) => {
    if (!files.length) return null;

    return (
      <div
  className="mt-3 d-flex flex-wrap"
  style={{
    gap: esFinanzas ? "24px" : "8px",
    alignItems: "flex-start"
  }}
>

        {files.map((item, idx) => {
          const esImagen = item.type?.startsWith("image/") || (item.url && !item.url?.endsWith('.pdf'));
          const srcUrl = item.url || item.preview;
          const nombreArchivo = item.name || (item.url?.split('/').pop() || 'archivo');
          const tamaño = item.size ? `${(item.size / 1024).toFixed(1)} KB` : '';

          return (
            <div key={`${item.id}-${idx}`} className="position-relative" style={{ display: "inline-block" }}>
              <div style={{ position: "relative", display: "inline-block" }}>
                {esImagen ? (
                  <img
  src={srcUrl}
  className="img-fluid rounded border"
  style={{
    width: esFinanzas ? "320px" : "80px",
    height: esFinanzas ? "320px" : "80px",
    objectFit: "contain",
    cursor: "pointer",
    backgroundColor: "#f8f9fa"
  }}
  alt="voucher"

                    onClick={() => setPreviewFile(item)}

                  />
                ) : (
                  <div 
                    className="border rounded p-2 text-center bg-light" 
                    style={{ width: "80px", height: "80px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }}
                    onClick={() => setPreviewFile(item)}

                  >
                    <i className="bi bi-file-earmark-pdf fs-2 text-danger" />
                    <small className="text-muted" style={{ fontSize: "10px" }}>PDF</small>
                  </div>
                )}
                {rol === "OPERACIONES" && (

  <button
    type="button"
    className="border-0"
    style={{
      position: "absolute",
      top: "0",
      right: "0",
      width: "24px",
      height: "24px",
      fontSize: "16px",
      fontWeight: "bold",
      backgroundColor: "#dc3545",
      color: "white",
      cursor: "pointer",
      borderRadius: "0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    }}
    onClick={() => handleRemoveFile(type, idx, item)}
    title="Eliminar"
  >
    −
  </button>
)}

              </div>
             {nombreArchivo && !esFinanzas && (
  <small className="text-muted d-block text-center mt-1" style={{ fontSize: "10px", maxWidth: "80px", overflow: "hidden", textOverflow: "ellipsis" }}>
    {nombreArchivo}
  </small>
)}
 {tamaño && !esFinanzas && (
  <small className="text-muted d-block text-center" style={{ fontSize: "9px" }}>
    {tamaño}
  </small>
)}
{esFinanzas && (
  <div className="mt-2 text-muted" style={{ fontSize: "12px", maxWidth: "320px" }}>
    <div>
      <strong>Fecha:</strong> {item.fecha_registro || "No registrada"}
    </div>
    <div>
      <strong>Subido por:</strong> {item.subido_por || "No registrado"}
    </div>
    <div>
      <strong>Área:</strong> {String(item.area_registro) === "1" ? "Experiencia" : "Ventas"}
    </div>
  </div>
)}


            </div>
          );
        })}
      </div>
    );
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="container-fluid py-2">
        {esFinanzas && (
  <div className="mb-3">
    <h5 className="mb-1">Registro de vouchers</h5>
    <small className="text-muted">
      Visualización de comprobantes adjuntos
    </small>
  </div>
)}

        {!esFinanzas && (
  <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-1">
              <i className="bi bi-receipt-cutoff me-2 text-primary" />
              Subir voucher de pago
            </h5>
            <small className="text-muted">
              ID: <span className="fw-bold text-primary">{id_dt_matricula_proyecto}</span>
            </small>
          </div>
          <span className="badge bg-light text-secondary border">
            <i className="bi bi-info-circle me-1" />
            Se pueden subir múltiples vouchers
          </span>
        </div>
)}
{!esFinanzas && (
        <div className="alert alert-primary py-2 mb-4">
          <div className="d-flex align-items-center">
            <i className="bi bi-shield-check me-2" />
            <div className="small">
              Selecciona o arrastra uno o más vouchers para subirlos.
            </div>
          </div>
        </div>
)}
        <div className="row g-3">
  {/* Columna Experiencia */}
  {puedeVerExperiencia && !esVentas && (
    <div className={cardColumnClass}>
      <div className="card shadow-sm h-100 border-0">
        {!esFinanzas && (
        <div className="card-header d-flex justify-content-between align-items-center py-2 bg-white border-0 border-bottom">
          <div className="d-flex align-items-center gap-2">
            <span className="avatar rounded-circle bg-primary bg-opacity-10 d-flex align-items-center justify-content-center">
              <i className="bi bi-mortarboard text-primary" />
            </span>
            <div>
              <h6 className="mb-0">Voucher de Experiencia</h6>
              <small className="text-muted">Comprobantes asociados al área de experiencia</small>
            </div>
          </div>

          {archivosVisiblesExperiencia.length > 0 && (
  <span className="badge bg-success bg-opacity-10 text-success">
    <i className="bi bi-check-circle me-1" /> {archivosVisiblesExperiencia.length} archivo(s)
  </span>
)}

        </div>
        )}
        <div className="card-body d-flex flex-column">
          {puedeSubirExperiencia ? (
            <div
              className={`rounded-4 p-3 mb-3 text-center position-relative ${experienceFiles.length > 0 ? "bg-success bg-opacity-10" : "bg-light"}`}
              style={{
                border: "2px dashed",
                borderColor: experienceFiles.length > 0 ? "#19875433" : "#6c757d66",
                cursor: "pointer",
                minHeight: "170px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                transition: "all 0.2s ease-in-out",
              }}
              onClick={() => expInputRef.current?.click()}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, "experience")}
            >
              <div className="mb-2">
                <i className="bi bi-cloud-arrow-up fs-1" />
              </div>
              <p className="mb-1 fw-semibold">Arrastra y suelta los vouchers aquí</p>
              <small className="text-muted d-block mb-1">o haz clic para seleccionar archivos</small>
              <small className="text-muted">Formatos permitidos: imágenes (JPG/PNG) o PDF</small>
              <input
                ref={expInputRef}
                type="file"
                className="d-none"
                multiple
                accept="image/*,.pdf"
                onChange={(e) => handleFileInputChange(e, "experience")}
              />
            </div>
          ) : null}

          {renderMiniPestanas(archivosVisiblesExperiencia, "experience")}

        </div>
      </div>
    </div>
  )}

  {/* Columna Ventas */}
  {puedeVerVentas && rol !== "EXPCLIENTE" && (

    <div className={cardColumnClass}>
      <div className="card shadow-sm h-100 border-0">
        {!esFinanzas && (
        <div className="card-header d-flex justify-content-between align-items-center py-2 bg-white border-0 border-bottom">
          <div className="d-flex align-items-center gap-2">
            <span className="avatar rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center">
              <i className="bi bi-cash-stack text-warning" />
            </span>
            <div>
              <h6 className="mb-0">Voucher de Ventas</h6>
              <small className="text-muted">Comprobantes asociados al área de Ventas</small>
            </div>
          </div>

          {archivosVisiblesVentas.length > 0 && (
  <span className="badge bg-success bg-opacity-10 text-success">
    <i className="bi bi-check-circle me-1" /> {archivosVisiblesVentas.length} archivo(s)
  </span>
)}

        </div>
         )}
        <div className="card-body d-flex flex-column">
          {puedeSubirVentas ? (
            <div
              className={`rounded-4 p-3 mb-3 text-center position-relative ${salesFiles.length > 0 ? "bg-success bg-opacity-10" : "bg-light"}`}
              style={{
                border: "2px dashed",
                borderColor: salesFiles.length > 0 ? "#19875433" : "#6c757d66",
                cursor: "pointer",
                minHeight: "170px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                transition: "all 0.2s ease-in-out",
              }}
              onClick={() => salesInputRef.current?.click()}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, "sales")}
            >
              <div className="mb-2">
                <i className="bi bi-cloud-arrow-up fs-1" />
              </div>
              <p className="mb-1 fw-semibold">Arrastra y suelta los vouchers aquí</p>
              <small className="text-muted d-block mb-1">o haz clic para seleccionar archivos</small>
              <small className="text-muted">Formatos permitidos: imágenes (JPG/PNG) o PDF</small>
              <input
                ref={salesInputRef}
                type="file"
                className="d-none"
                multiple
                accept="image/*,.pdf"
                onChange={(e) => handleFileInputChange(e, "sales")}
              />
            </div>
                   ) : null}



          {renderMiniPestanas(archivosVisiblesVentas, "sales")}
        </div>
      </div>
    </div>
  )}
</div>

{previewFile && (
  <div
    className="position-fixed d-flex align-items-center justify-content-center"
    style={{
      inset: 0,
      zIndex: 9999,
      backgroundColor: "rgba(0, 0, 0, 0.55)",
      padding: "24px"
    }}
    onClick={() => setPreviewFile(null)}
  >
    <div
      className="position-relative"
      style={{
        maxWidth: "92vw",
        maxHeight: "92vh"
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <button
        type="button"
        className="btn btn-light btn-sm position-absolute"
        style={{
          top: "10px",
          right: "10px",
          zIndex: 2
        }}
        onClick={() => setPreviewFile(null)}
      >
        Cerrar
      </button>

      {previewFile.type?.includes("pdf") || previewFile.name?.toLowerCase().endsWith(".pdf") ? (
        <iframe
          src={previewFile.url || previewFile.preview}
          title="Vista previa PDF"
          style={{
            width: "88vw",
            height: "88vh",
            border: "0",
            borderRadius: "6px",
            backgroundColor: "transparent"
          }}
        />
      ) : (
        <img
          src={previewFile.url || previewFile.preview}
          alt="Vista previa voucher"
          style={{
            maxWidth: "88vw",
            maxHeight: "88vh",
            objectFit: "contain",
            borderRadius: "6px",
            backgroundColor: "transparent"
          }}
        />
      )}
    </div>
  </div>
)}

<div className="mt-4 d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2">

          {!esFinanzas && (
  <div className="small text-muted">
    <i className="bi bi-exclamation-circle me-1" />
    Recuerda que los vouchers deben ser legibles y corresponder al registro de pago seleccionado.
  </div>
)}

          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-outline-secondary" onClick={() => {
  if (huboCambios && onVoucherDeleted) onVoucherDeleted();
  onClose();
}}>
  {esFinanzas ? "Cerrar" : "Cancelar"}
</button>

{!esFinanzas && (
  <button type="submit" className="btn btn-primary" disabled={experienceFiles.length === 0 && salesFiles.length === 0}>
    <i className="bi bi-save me-1" /> Guardar vouchers ({experienceFiles.length + salesFiles.length})
  </button>
)}

          </div>
        </div>
      </div>
    </form>
  );
};

AddNewVoucherModal.propTypes = {
  onClose: PropTypes.func,
  id_dt_matricula_proyecto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  tp_cuota: PropTypes.any,
  archivosExistentes: PropTypes.array,
  areaRegistro: PropTypes.string,
};

export default AddNewVoucherModal;